/**
 * Cart Kit Inventory Validator Hook
 * 
 * Hooks into the cart's quantity selector to validate kit inventory
 * before allowing quantity increases.
 */

(function() {
  'use strict';

  // Wait for theme to be ready
  function initCartKitValidation() {
    // Hook into cart quantity change events
    document.addEventListener('change', async function(e) {
      const input = e.target;
      
      // Only process quantity inputs in cart
      if (!input.matches('[data-quantity-input][data-update-cart]')) {
        return;
      }

      // Skip if validator not loaded
      if (!window.KitInventoryValidator) {
        return;
      }

      const requestedQty = parseInt(input.value, 10);
      if (isNaN(requestedQty)) return;

      // Validate kit inventory
      const validation = await window.KitInventoryValidator.validateCartQuantity(input, requestedQty);
      
      if (!validation.valid) {
        // Set to max allowed
        input.value = validation.maxAllowed;
        
        // Show error in cart
        showCartError(input, validation.error);
        
        // Prevent cart update with invalid quantity
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true); // Use capture phase to intercept early

    // Also hook into +/- button clicks
    document.addEventListener('click', async function(e) {
      const increaseBtn = e.target.closest('[data-increase-quantity]');
      const decreaseBtn = e.target.closest('[data-decrease-quantity]');
      
      if (!increaseBtn && !decreaseBtn) return;
      if (!window.KitInventoryValidator) return;

      const wrapper = (increaseBtn || decreaseBtn).closest('[data-quantity-selector]');
      if (!wrapper) return;

      const input = wrapper.querySelector('[data-quantity-input][data-update-cart]');
      if (!input) return;

      // For increase, check before increment
      if (increaseBtn) {
        const currentQty = parseInt(input.value, 10);
        const requestedQty = currentQty + 1;
        
        const validation = await window.KitInventoryValidator.validateCartQuantity(input, requestedQty);
        
        if (!validation.valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          
          // Show error
          showCartError(input, validation.error);
          
          return false;
        }
      }
    }, true);

    // Also validate manual input changes
    document.body.addEventListener('input', debounce(async function(e) {
      const input = e.target;
      if (!input.matches('[data-quantity-input][data-update-cart]')) return;
      if (!window.KitInventoryValidator) return;

      const requestedQty = parseInt(input.value, 10);
      if (isNaN(requestedQty) || requestedQty < 1) return;

      const validation = await window.KitInventoryValidator.validateCartQuantity(input, requestedQty);

      if (!validation.valid) {
        input.value = validation.maxAllowed;
        showCartError(input, validation.error);
      }
    }, 500), true);
  }

  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  /**
   * Shows error message in cart
   * @param {HTMLElement} input - The quantity input
   * @param {string} message - Error message
   */
  function showCartError(input, message) {
    // Find the cart item container
    const cartItem = input.closest('[data-cart-item]');
    if (!cartItem) return;

    // Find or create error container
    let errorContainer = cartItem.querySelector('[data-kit-error]');
    
    if (!errorContainer) {
      // Create error container below the quantity selector
      errorContainer = document.createElement('div');
      errorContainer.setAttribute('data-kit-error', '');
      errorContainer.style.cssText = 'color: #d02e2e; font-size: 0.875rem; margin-top: 0.5rem; grid-column: 1 / -1;';
      
      // Insert after the cart item grid
      const grid = cartItem.querySelector('.cart__items__grid');
      if (grid) {
        grid.parentNode.insertBefore(errorContainer, grid.nextSibling);
      }
    }

    errorContainer.innerHTML = `<strong>${message}</strong>`;
    errorContainer.style.display = 'block';

    // Auto-hide after 5 seconds
    setTimeout(() => {
      if (errorContainer) {
        errorContainer.style.display = 'none';
      }
    }, 5000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartKitValidation);
  } else {
    initCartKitValidation();
  }

  // Also re-initialize after cart updates
  document.addEventListener('theme:cart:reload', function() {
    // Clear existing error messages
    document.querySelectorAll('[data-kit-error]').forEach(el => {
      el.style.display = 'none';
    });
  });

})();
